module.exports = __webpack_public_path__ + "static/media/en-flag.2968fc2a.svg";